import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getLedgerById } from '@/api/ledgers';
import LedgerInfoTab from './LedgerInfoTab.vue';
import LedgerUserTab from './LedgerUserTab.vue';
import LedgerProductTab from './LedgerProductTab.vue';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.ledgerId = null;
    this.ledgerInfoData = null;
  }
  activated() {
    this.ledgerId = this.$route.params.id;
    this.getLedgerInfo();
  }
  async getLedgerInfo() {
    try {
      this.ledgerInfoData = await getLedgerById(this.ledgerId);
    } catch (error) {
      this.$message(error.toString());
    }
  }
};
default_1 = __decorate([Component({
  name: 'LedgerInfo',
  components: {
    LedgerInfoTab,
    LedgerUserTab,
    LedgerProductTab
  }
})], default_1);
export default default_1;